/**
 * Centralized API endpoint registry.
 * Use this for all backend interactions to ensure consistency.
 */
export const ENDPOINTS = {
  ASSISTANT: {
    DELETE_SESSION: (sessionId: string) => `/assistant/sessions/${sessionId}`,
    ENHANCE_PROMPT: '/assistant/enhance-prompt',
    GET_SESSION_HISTORY: (sessionId: string) => `/assistant/sessions/${sessionId}/messages`,
    LIST_FOLDERS: '/assistant/folders',
    LIST_SESSIONS: '/assistant/sessions',
    SEND_MESSAGE: '/assistant/chat',
    SESSION_CONTEXT: '/assistant/sessions/context',
  },
  ATTACHMENTS: {
    BULK_DELETE: '/attachments/bulk-delete',
    BULK_UPLOAD: '/attachments/bulk-upload',
    DELETE: (id: string) => `/attachments/${id}`,
    DOWNLOAD: (id: string) => `/attachments/${id}/download`,
    LIST: '/attachments/list',
    UPLOAD: '/attachments/upload',
  },
  AUTH: {
    CONNECT_MAILBOX: '/auth/connect-mailbox',
    DEVICE_EXCHANGE: '/auth/device/exchange',
    DEVICE_REFRESH: '/auth/device/refresh',
    DEVICE_REVOKE: '/auth/device/revoke',
    LOGOUT: '/auth/logout',
    ME: '/auth/me',
  },
  AUTOMATIONS: {
    CREATE: '/automations',
    DELETE: (id: string) => `/automations/${id}`,
    GET: (id: string) => `/automations/${id}`,
    LIST: '/automations',
    RUNS: (id: string) => `/automations/${id}/runs`,
    UPDATE: (id: string) => `/automations/${id}`,
  },
  INBOX: {
    CONTEXT_EMAILS: '/inbox/context-emails',
    FETCH: '/inbox/fetch',
  },
  NARRATIVE: {
    DELETE: (id: string) => `/narrative/${id}`,
    GET_WALKTHROUGH: '/narrative/walkthrough',
    JOBS: '/narrative/jobs',
    LIST: '/narrative',
    PREFERENCES: '/user/narrative-preferences',
    TRIGGER: '/narrative/trigger',
    UPDATE: (id: string) => `/narrative/${id}`,
    WALKTHROUGH_STEP: '/narrative/walkthrough/step',
  },
  TRANSCRIPTION: {
    TRANSCRIBE: '/transcription/transcribe',
  },
  USER: {
    ASSISTANT_PREFERENCES: '/user/assistant-preferences',
    GENERATE_PROFILE: '/user/generate-profile',
    INITIAL_SYNC_STATUS: '/user/initial-sync-status',
    INTERCOM: '/user/intercom',
    SAVE_PROFILE: '/user/assistant-preferences/profile',
  },
} as const;
